import axios from 'axios';

import { API } from 'consts';

const BASE_URL = `${API.URL}/${API.VERSION}`;

// needs_reconnect and prompt_reconnect are decided by web-be, the only place
// the 30-day window lives; refresh_expires_at is for display.
export interface AdvocacyStatus {
  connection_status: 'connected' | 'needs_reconnect' | 'not_connected';
  needs_reconnect: boolean;
  prompt_reconnect: boolean;
  last_verified_at: string | null;
  refresh_expires_at: string | null;
}

// No advocate id: web-be answers for the caller's own session.
export const getAdvocacyStatus = async (
  token: string,
): Promise<AdvocacyStatus> => {
  const response = await axios({
    method: 'GET',
    url: `${BASE_URL}/linkedin/advocacy/status`,
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data.data;
};
